var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "credit-cost-box" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", { staticClass: "font-weight-bold" }, [
        _vm._v(_vm._s(_vm._f("trans")("Credit Cost"))),
      ]),
    ]),
    _vm._v(" "),
    _vm.isLegacyUser === true
      ? _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v(_vm._s(_vm._f("trans")("Total Cost")))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "credit-cost-badge" },
            [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.totalCost)),
              ]),
              _vm._v(" "),
              _c("CoinSVG"),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLegacyUser === false
      ? _c("div", { staticClass: "d-flex justify-content-between" }, [
          _c("span", [_vm._v(_vm._s(_vm._f("trans")("Total Cost")))]),
          _vm._v(" "),
          _c("div", { staticClass: "credit-cost-badge" }, [
            _c(
              "span",
              {
                staticClass:
                  "font-weight-bold d-flex align-items-center credit-cost-indicator",
              },
              [
                _c(
                  "span",
                  { staticClass: "d-flex align-items-center gap-5" },
                  [_vm._v("\n               8  "), _c("CoinSVG")],
                  1
                ),
                _vm._v("\n           /\n            "),
                _vm._m(0),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("span", [_vm._v(_vm._s(_vm._f("trans")("Your Balance")))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "credit-cost-badge" },
        [
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(_vm._s(_vm.userAvailableCredits)),
          ]),
          _vm._v(" "),
          _c("CoinSVG"),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "credit-cost-btn", on: { click: _vm.getMoreCredits } },
      [
        _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Get more Credits")))]),
        _c("i", { staticClass: "fa lh-inherit fa-chevron-right" }),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "d-flex align-items-center gap-5" }, [
      _vm._v("\n            10s "),
      _c("i", { staticClass: "far font-weight-bold fa-clock" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }